import { render, staticRenderFns } from "./CommonLayout.vue?vue&type=template&id=a3533e54&scoped=true"
import script from "./CommonLayout.vue?vue&type=script&lang=js"
export * from "./CommonLayout.vue?vue&type=script&lang=js"
import style0 from "./CommonLayout.vue?vue&type=style&index=0&id=a3533e54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3533e54",
  null
  
)

export default component.exports